
/* ========================================================================
 *
 * Custom site functions
 *
 * ======================================================================== */

$(function() {

/* ========================================================================
 *  back-to-top
 * ======================================================================== */
jQuery('.back-to-top').on( 'click', function(){
	jQuery("html, body").animate({ scrollTop: 0 });
});

/* ========================================================================
 *  remove the New title
 * ======================================================================== */
jQuery('h4').each( function(){
	if (jQuery(this).text() === 'New title') {
		jQuery(this).hide();
	}
});

/* ========================================================================
 *  Open external links in new window
 * ======================================================================== */
// jQuery('a').each(function() {
// 	 var a = new RegExp('/' + window.location.host + '/');
// 	 if(!a.test(this.href)) {
// 		 jQuery(this).click(function(event) {
//
// 			if (jQuery(this).attr('id') === 'consoleWorkspace-close') {
// 				return;
// 			}
//
// 			event.preventDefault();
// 			event.stopPropagation();
// 			window.open(this.href, '_blank');
// 		 });
// 	 }
// });

/* ========================================================================
 *	share-link-trigger
 * ======================================================================== */
	jQuery('.share-link-trigger').on('click', function(event){

		if (jQuery(this).attr('href')) {
        	event.stopPropagation();
        	event.preventDefault();
			window.open(jQuery(this).attr('href'), "_blank", "toolbar=no, scrollbars=yes, resizable=yes, top=1, left=1, width=620, height=520");
		}
	});

/* ========================================================================
 *	share-email-trigger
 * ======================================================================== */
   jQuery('.share-email-trigger').on('click', function(e){

		e.stopPropagation();
    	e.preventDefault();

		jQuery('.form-dimm').fadeToggle();
		jQuery('#form-overlay-share').fadeToggle();
		jQuery('#form-overlay-share').css( 'top', '100px' );
		jQuery("html, body").animate({ scrollTop: '50%' }, 500);
		return;
	});

	jQuery('.form-close').on('click', function(){

		jQuery('.form-dimm').hide();
		jQuery('.form-overlay').hide();

		jQuery('.form-overlay-video-inner').empty();

	});

/* ========================================================================
 *	Sticky sidebar
 * ======================================================================== */
	/*

	var width = jQuery(window).width();

	if (width > 1130)
	{
		jQuery('.sectionnav').scrollToFixed( {
			limit: 			((jQuery('footer.content-info').offset().top) - (jQuery('.sectionnav').height()) + 20),
			left: 			2,
			top: 			-5,
			removeOffsets: 	true,
			minWidth: 		1130,
			marginTop: 		110
		});
	}
	*/

});
